import { render, staticRenderFns } from "./article-timeafter.vue?vue&type=template&id=920ad21e&scoped=true"
import script from "./article-timeafter.vue?vue&type=script&lang=js"
export * from "./article-timeafter.vue?vue&type=script&lang=js"
import style0 from "./article-timeafter.vue?vue&type=style&index=0&id=920ad21e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920ad21e",
  null
  
)

export default component.exports